import React, {Component} from 'react';
//import {Link} from "react-router-dom";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
//import pending from "../assets/img/pending.png";
//import approve from "../assets/img/approve.png";
//import reject from "../assets/img/reject.png";
import {Button} from "reactstrap";
import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class NewUnmappedView extends Component {
    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            //loading: false,
            file_id: null,
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: '',
               
            },
            unmappedModel: false,
            data:[],
            raw_display_data: [],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            changedItems:[],
            isChange: false
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        console.log(this.props.match.params);
        this._refreshUnmapped_View();
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem,
            file_id: this.props.match.params.id       
        });
        //var _notificationSystem = this.refs.notificationSystem;
    }
    
    unmappedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            unmappedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            unmappedModel: !this.state.unmappedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }


    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }


    _refreshUnmapped_View() {
        if ($.fn.DataTable.isDataTable('#unmappedViewTable')) {
            $('#unmappedViewTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL') + '/brandemi/get_unmapped_data_new',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            $('#unmappedViewTable').DataTable();
            this.setState({
                loading: false
            });
            this.preAppender();

        });
    }

    preAppender(){
        this.state.raw_display_data.map((value, key) => {
            this.setState({
                changedItems: {...this.state.changedItems, [key]:value[1][0].sku + "$" + value[1][0].brand + "$" + value[1][0].description + "$" + value[1][0].mrp},
                isChange: false
            });
            return null;
        });
    }

    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });

                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };

 
    render() {
        console.log(this.state.changedItems);    
        //console.log(this.state.relationData);

        let unmapped_data = this.state.raw_display_data.map((value,index) => {
            //this.preAppender(this, value[0].item_no);
            //console.log(this.state.raw_display_data[index][1][0].sku);
            /*this.setState({
                changedItems: {...this.state.changedItems, [index]:this.state.raw_display_data[index][1][0].sku}//,
                //isChange: true
            });*/
            let optioner = value[1].map((value2,index) => {
                return(
                    <option value={value2.sku + "$" + value2.brand + "$" + value2.description + "$" + value2.mrp} key={index+1 + "_" + value2.sku}>{"sku: " + value2.sku + " brand: " + value2.brand + " desc: " + value2.description + " price: " + value2.mrp}</option>
                );
            });
            //let indicator = "All";
            return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value[0].merchant_sku}</td>
                    <td>{value[0].merchant_description}</td>
                    <td>{value[0].merchant_mrp}</td>
                    <td>    
                        <select name="permissionType" className="form-control clmatch" onChange={this.handleChange.bind(this, value[0].item_no)}>
                            {/*console.log(value[0][1].brand)*/}
                            {/*, value[0].merchant_sku, value[0].merchant_brand, value[0].merchant_description, value[0].merchant_mrp*/}
                            {optioner}
                            {/*<option value="All" >{value[1][0].sku + " " + value[1][0].brand + " " + value[1][0].description + " " + value[1][0].mrp}</option>*/}
                            {/*selected={val.permission == "All"}*/}
                            {/*<option value="Self" >{value[1][1].sku + " " + value[1][1].brand + " " + value[1][1].description + " " + value[1][1].mrp}</option>*/}
                            {/*selected={val.permission=="Self"}*/}
                            {/*<option value="None">{value[1][2].sku + " " + value[1][2].brand + " " + value[1][2].description + " " + value[1][2].mrp}</option>*/}
                            {/* selected={val.permission=="None"}*/}
                            {/*<option value="None1">{value[1][3].sku + " " + value[1][3].brand + " " + value[1][3].description + " " + value[1][3].mrp}</option>*/}
                            {/*<option value="None2">{value[1][4].sku + " " + value[1][4].brand + " " + value[1][4].description + " " + value[1][4].mrp}</option>*/}
                        </select>
                    </td>
                </tr>
            )
        });

        
        return(
            <div className="card">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="content table-full-width table-responsive">
                        <div className="row">
                            <div classname="col-md-12">
                                <table className="table table-striped table-hover" id="unmappedViewTable">
                                    <thead>
                                    <tr>
                                        <th>Sr No.</th>
                                        <th>Merchant SKU</th>
                                        <th>Merchant Description</th>
                                        <th>Merchant Price</th>
                                        <th>Closest Brand Data Match</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {unmapped_data}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <Button color="primary" onClick={this.mappingHandler}>Map Data</Button>{' '}
                            </div>
                        </div>
                    </div>
                </div>
                    

            <div className="footer">  
                {/*<Link className="viewButton" data-tip="View"  ><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>*/}
                <div className="stats"><i></i></div>
            </div>

        </div>
        );
    }
}
export default NewUnmappedView;